import { fetchOpenAIText } from "../utils/openaiClient";

export function useFourOpinionsGeneratorLogic({
  fourOpinionsInput, setFourOpinionsInput, fourOpinionsLevel, fourOpinionsCount, setFourOpinionsCount,
  setFourOpinionsLoading, generatedFourOpinions, setGeneratedFourOpinions,
  currentTab, onInsertToBoard, editor, activeEditor,
  setShowFourOpinionsGenerator, setSelectedTemplate,
}) {
  const handleFourOpinionsGenerate = async () => {
    if (!fourOpinionsInput.trim()) return;

    setFourOpinionsLoading(true);
    try {
      const levelInstructions = {
        'A1': 'Use very simple vocabulary and short sentences. Avoid complex grammar structures.',
        'A2': 'Use basic vocabulary and simple sentence structures. Include common everyday expressions.',
        'B1': 'Use intermediate vocabulary and varied sentence structures. Include some complex ideas.',
        'B2': 'Use advanced vocabulary and complex sentence structures. Include nuanced perspectives.',
        'C1': 'Use sophisticated vocabulary and complex grammar. Include academic-level discourse.',
        'C2': 'Use highly sophisticated vocabulary and complex structures. Include nuanced, academic-level analysis.'
      };

      const prompt = `Create ${fourOpinionsCount} different opinions by different people on the following topic. Each opinion should be 2-3 sentences long and reflect different perspectives. ${levelInstructions[fourOpinionsLevel] || levelInstructions['B1']} Format the response as a JSON object with an array of opinions, each containing a "name" and "opinion" field. The names should be realistic and diverse. Topic: ${fourOpinionsInput}. Level: ${fourOpinionsLevel}`;



      const content = await fetchOpenAIText({
        prompt,
        temperature: 0.7,
        maxTokens: 800,
      });

      if (content) {
        try {
          const contentStr = content.trim();


          const jsonMatch = contentStr.match(/\{[\s\S]*\}/);
          if (jsonMatch) {
            const parsed = JSON.parse(jsonMatch[0]);

            setGeneratedFourOpinions(parsed);
          } else {

            setGeneratedFourOpinions({ opinions: [] });
          }
        } catch (parseError) {
          setGeneratedFourOpinions({ opinions: [] });
        }
      }
    } catch (e) {
      // Error generating four opinions
    } finally {
      setFourOpinionsLoading(false);
    }
  };

  const handleFourOpinionsInsert = () => {


    if (currentTab > 0 && onInsertToBoard && generatedFourOpinions) {
      onInsertToBoard(generatedFourOpinions, 'fouropinions');
      setShowFourOpinionsGenerator(false);
      setFourOpinionsInput("");
      setSelectedTemplate(null);
      return;
    }
    if (generatedFourOpinions && editor) {
      const opinions = generatedFourOpinions.opinions || [];
      const exerciseData = {
        title: 'Four Opinions',
        level: fourOpinionsLevel,
        topic: fourOpinionsInput,
        opinions: opinions
      };



      try {
        activeEditor.chain().focus().insertFourOpinionsExercise(exerciseData).run();

      } catch (error) {
        // Error inserting four opinions
      }
    } else {

    }

    setShowFourOpinionsGenerator(false);
    setFourOpinionsInput("");
    setSelectedTemplate(null);
  };

  const handleFourOpinionsCancel = () => {
    setShowFourOpinionsGenerator(false);
    setFourOpinionsInput("");
    setFourOpinionsCount(4);
    setGeneratedFourOpinions(null);
    setSelectedTemplate(null);
  };

  return { handleFourOpinionsGenerate, handleFourOpinionsInsert, handleFourOpinionsCancel };
}
